// file_processor/router/index.js
export const fileProcessorRoutes = [
    // {
    //     path: '',
    //     redirect: '/file-processor/history'
    // },
    {
        path: 'history',
        name: 'FileHistory',
        component: () => import('../views/HistoryPage.vue'),
        meta: {title: '转换记录'}
    },
    {
        path: 'chat',
        name: 'FileChat',
        component: () => import('../views/ChatPage.vue'),
        meta: {title: '智能聊天'}
    },
    {
        path: 'discover',
        name: 'FileDiscover',
        component: () => import('../views/DiscoverPage.vue'),
        meta: {title: '发现'}
    },
    {
        path: 'profile',
        name: 'FileProfile',
        component: () => import('../views/ProfilePage.vue'),
        meta: {title: '我的助手'}
    },
    {
        path: 'account-setting',
        name: 'FileProcessorAccountSetting',
        component: () => import('../views/AccountSetting.vue'),
        meta: {
            title: '账号设置',
            hideBottomNav: true // 告诉父组件：进入这个页面时，把底部栏藏起来！
        }
    },
    {
        path: 'receiver',
        name: 'FileReceiver',
        component: () => import('../views/FileReceiverPage.vue'),
        meta: {
            title: '接收外部文件',
            hideBottomNav: true // 隐藏底部栏
        }
    },
    {
        path: 'viewer',
        name: 'FileViewer',
        component: () => import('../views/FileViewerPage.vue'),
        meta: {
            title: '文件预览',
            hideBottomNav: true // 隐藏底部栏
        }
    }
];